import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Button from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import type { MediaCardVideoIconProps } from '../../types';

const useStyles = makeStyles((theme: Theme) => ({
  cardVideoIcon: {
    zIndex: 1,
    position: 'absolute',
    right: '10px',
    top: '80px',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.text.primary,
      padding: '2px',
      backgroundColor: theme.palette.background.default,
      borderRadius: '4px',
    },
  },
  button: {
    minWidth: 'auto',
  },
}));

const MediaCardVideoIcon: React.FC<MediaCardVideoIconProps> = ({ onClickHandler }) => {
  const classes = useStyles();
  const anchorRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <div className={classes.cardVideoIcon} ref={anchorRef}>
      <Button
        variant="text"
        color="primary"
        size="small"
        aria-label="select merge strategy"
        aria-haspopup="menu"
        classes={{ root: classes.button }}
        onClick={onClickHandler}
      >
        <PlayCircleIcon />
      </Button>
    </div>
  );
};

export default MediaCardVideoIcon;
